export default {
  'primaryColor': '#309AB7',
  'secondaryColor': '#f60a4f',
  'orange': '#fab05a',
  'green': '#4ac730',
  'blue': '#8dccea',
  'host': 'https://api.cryptalks.app/',
  'client': 'https://web.cryptalks.app/'
}